<template>
  <info-header />
</template>

<script setup lang="ts">
import InfoHeader from '@/vue/InfoHeader.vue';
</script>